import { useEffect, useRef } from 'react';
import { useThree } from '@react-three/fiber';
import { registerEditorRenderer, unregisterEditorRenderer } from '../utils/rendererRegistry';

/**
 * Registers the WebGL renderer with the global registry
 * Should be placed inside the Canvas component
 */
export default function RendererRegistry() {
  const { gl } = useThree();
  const registered = useRef(false);

  useEffect(() => {
    if (!registered.current) {
      registerEditorRenderer(gl);
      registered.current = true;
    }

    return () => {
      unregisterEditorRenderer();
      registered.current = false;
    };
  }, [gl]);

  return null;
}
